import React from 'react';
import { statusBadgeTone } from '../../design-system';

/**
 * Central status / pill badge. tone: success | warning | danger | info | neutral | brand
 */
export default function StatusBadge({
  children,
  tone = 'neutral',
  className = '',
  uppercase = true,
}) {
  const toneClass = statusBadgeTone[tone] || statusBadgeTone.neutral;
  return (
    <span
      className={[
        'inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-black tracking-wide',
        uppercase ? 'uppercase' : '',
        toneClass,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </span>
  );
}
